import { Daily10LogScreen } from '@/screens/daily10/Daily10LogScreen'

export default function Daily10LogRoute() {
  return <Daily10LogScreen />
}
